// extracted by mini-css-extract-plugin
module.exports = {"jobCardLocation":"JobLocation-module_jobCardLocation_b5945","locationIcon":"JobLocation-module_locationIcon_beb6a","locationText":"JobLocation-module_locationText_090c1"};